import PublicApiServers from './PublicApiServers';
export default class PublicApiConfig {

    constructor(config) {
        config = config || {};
        this.apiServer = config.apiServer || PublicApiServers.production;
        this.version = config.version || 1;
        this.timeoutInMs = config.timeoutInMs || 15000;
        this.publicApiKey = config.publicApiKey || '61d816a610074968ad54c36853c9280f';
        this.debug = config.debug;
        // this.mode = 'cors';
    }

}
PublicApiConfig.Servers = PublicApiServers;



// WEBPACK FOOTER //
// ./src/Utils/PublicApiConfig.js


// WEBPACK FOOTER //
// webpack:///src/Utils/PublicApiConfig.js